import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { cancelAndExit } from '@cli-utils/terminal.js'

export function cancel(context: SchemaPromptContext): never {
  cancelAndExit(context.cancelMessage)
}
